module.exports = __webpack_public_path__ + "static/media/icon-sports.1801d5f9.svg";